import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IResponseBaseTDto from '../../API/Interfaces/IResponseBaseTDto';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import EntityDetails, { IEntityDetailsProps, IEntityDetailsBaseProps } from '../../Layout/EntityDetails';
import DetailsBox from '../../Layout/Components/DetailsBox';
import {
	DealerDetailsIcon,
	StarIcon,
	LocationChainIcon,
	CorporationAdminDetailsIcon,
	LocationAdminDetailsIcon,
	LocationIcon,
} from '../../Layout/Components/Icons';
import DetailsError from '../../Layout/Components/DetailsError';
import { DealerAdminServiceAPI } from '../../API/Services/UserServicesAPI';
import { IUserDetailsDto } from '../../API/Interfaces/IUserDtos';
import { formatPhoneNumber, UserRole } from '../../Constants/constants';

export const User = (props: IEntityDetailsBaseProps) => {
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();

	const { id } = useParams<{ id: string }>();
	const [entity, setEntity] = useState(props.entity);
	const [noData, setNoData] = useState(false);
	const errorDialog = (message?: string) =>
		enqueueSnackbar(`${t('common.errorOccured')}${message ? ': ' : ''}${message && message}`, { variant: 'error' });

	const fetchEntity = async function (id: string) {
		try {
			const response: IResponseBaseTDto<IUserDetailsDto> = await DealerAdminServiceAPI.GetOne(id);
			if (response) return response;
		} catch (e) {
			errorDialog(e.message);
		}
		return undefined;
	};

	const getDevice = async () => {
		if (id) {
			const e = await fetchEntity(id);
			if (e) {
				setEntity(e);
			} else setNoData(true);
		}
	};

	useEffect(() => {
		getDevice();

		// eslint-disable-next-line
	}, []);

	const detailsProps: IEntityDetailsProps = {
		detailTitle: entity?.firstName + ' ' + entity?.lastName || '',
		entityType: t('users.table.nameHeader'),
		entity: entity,
		api: DealerAdminServiceAPI,
		isEditable: false,
		isRemovable: false,
		openModal: () => {},
		entityDetailsComponent: <></>,
		entityActionIconsComponent: <></>,
		entitySubsetTableComponent: (
			<>
				{entity && entity.role === UserRole.DealerAdmin ? (
					<DetailsBox
						icon={DealerDetailsIcon}
						schema={[
							{
								title: t('user.details.dealerData'),
								dataElement: (
									<>
										<a href={`mailto:${entity.email}`} style={{ textDecoration: 'none', color: '#4200ff' }}>
											{entity.email}
										</a>
										<div>{formatPhoneNumber(entity.phone)}</div>
									</>
								),
								rowWithIcon: [{ icon: <StarIcon />, text: entity.location }],
							},
						]}
					/>
				) : entity && entity.role === UserRole.CorporationAdmin ? (
					<DetailsBox
						icon={CorporationAdminDetailsIcon}
						schema={[
							{
								title: t('user.details.corporationData'),
								dataElement: <div>ul. {entity.address}</div>,
								rowWithIcon: [{ icon: <LocationChainIcon />, text: entity.location }],
							},
							{
								title: t('user.details.adminData'),
								dataElement: (
									<>
										<a href={`mailto:${entity.email}`} style={{ textDecoration: 'none', color: '#4200ff' }}>
											{entity.email}
										</a>
										<div>{formatPhoneNumber(entity.phone)}</div>
									</>
								),
							},
						]}
					/>
				) : entity && entity.role === UserRole.LocationAdmin ? (
					<DetailsBox
						icon={LocationAdminDetailsIcon}
						schema={[
							{
								title: t('location.locationData'),
								dataElement: (
									<>
										<div>ul. {entity.address}</div>
										<div style={{ display: 'flex', margin: '0 0 0 2px' }}>
											<div style={{ alignItems: 'center', display: 'flex' }}>
												<LocationChainIcon />
												<div style={{ marginLeft: '5px' }}>{entity.corporationName}</div>
											</div>

											<div style={{ alignItems: 'center', display: 'flex', marginLeft: '10px' }}>
												<LocationIcon />
												<div style={{ marginLeft: '5px' }}>{entity.location}</div>
											</div>
										</div>
									</>
								),
							},
							{
								title: t('user.details.adminData'),
								dataElement: (
									<>
										<a href={`mailto:${entity.email}`} style={{ textDecoration: 'none', color: '#4200ff' }}>
											{entity.email}
										</a>
										<div>{formatPhoneNumber(entity.phone)}</div>
									</>
								),
							},
						]}
					/>
				) : null}
			</>
		),
		headerButtons: <></>,
	};
	return noData ? <DetailsError /> : <EntityDetails {...detailsProps} />;
};
